import type { Address } from './address'
import type { CallEvent } from './callEvent'
import type { CallReport } from './callReport'
import type { Customer } from './customer'
import type { Option } from './option'
import type { User } from './user'

export const FEEDBACK_REPORT_REASON_ID = "00000000-0000-0000-0000-000000000000"

export interface Call {
    id: string
    number: string
    user?: User
    user_id?: string
    transferrer?: User
    transferrer_id?: string
    caller_user_id?: string
    caller?: Customer
    customer: Customer
    address?: Address
    reports?: CallReport[]
    events?: CallEvent[]
    call_reason?: Option
    call_decision?: Option
    diagnosis?: Option
    final_decision?: CallFinalDecision[]
    room_sid?: string
    status: CallStatus
    source: CallSource
    created_at: string
    connected_at?: string
    on_hold_at?: string
    ended_at?: string
    metadata?: {
        priority?: string
        feedback?: {
            timestamp: string
            rating: number
            comment?: string
        }
    }
}

export interface CallFinalDecision {
    call_decision_id?: string
    decided_by?: string
    decision?: Option
}

export enum CallStatus {
    new = 'new',
    active = 'active',
    onHold = 'on_hold',
    resolved = 'resolved',
    unresolved = 'unresolved',
    falseCall = 'false_call',
    timedOut = 'timed_out',
}

export enum CallSource {
    app = 'app',
    external = 'external',
}

export enum CallCenterAlert {
    severe = 'severe',
    warning = 'warning',
    info = 'info',
}

export interface CallCenterPreferences {
    ringerDeviceId?: string
    extension?: string
    extensionToken?: string
}

export interface CallCenterState {
    activeCallId?: string
    activeWindowId?: string
    alertedCalls?: string[]
    preferences?: CallCenterPreferences
}

export interface CallRecording {
    id: string
    media?: string
    duration?: number
    processed_at?: string
}